export default {
  "DASHBOARD": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tableau de Bord"])},
  "THIS_MONTH": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ce mois"])}
}